// NOTE: @/views/Map.vue以外でMIXINする場合は@/mixins/googlemaps.jsが必須

import { mapGetters } from "vuex";
export default {
  methods: {
    ...mapGetters(["getLandmarks"]),

    /**
     * ランドマークのアイコンをマップ上に表示します。
     * 予め `retrieveLandmarks` でデータを取得しておく必要があります。
     *
     * @param {function} callback ランドマーク1件分のMarkerを生成・セットアップした後にこの関数を呼び出します
     */
    putLandmarkMarkers(callback) {
      const { Marker } = this.google.maps;
      let landmarks = this.getLandmarks();
      landmarks.forEach(landmark => {
        const lat = parseFloat(landmark.latitude);
        const lng = parseFloat(landmark.longitude);

        const marker = new Marker({
          position: { lat: lat, lng: lng },
          map: this.map,
          icon: this.buildMarkerIconProps(landmark.icon),
          draggable: false
        });
        marker.set("landmark", landmark);
        this.setInfoWindow(marker, landmark);

        callback(marker);
      });
    },

    buildMarkerIconProps(iconName) {
      // アイコンファイル名の組み立て
      let iconProps = { url: this.buildMarkerIcon(iconName) };
      iconProps = Object.assign(iconProps, {
        scaledSize: { width: 42, height: 42 },
        anchor: { x: 21, y: 21 }
      });
      return iconProps;
    },

    buildMarkerIcon(iconName) {
      return require("@/assets/icons/landmarks/" + iconName);
    },

    setInfoWindow(marker, landmark) {
      var message = [];
      if (landmark.name) {
        message.push(landmark.name);
      }

      // InfoWindowで表示する情報がある場合のみ以下を設定
      if (message.length > 0) {
        var infowin = new this.google.maps.InfoWindow({
          content: message.join("<br>")
        });

        // mouseoverイベントを取得するListenerを追加
        this.google.maps.event.addListener(marker, "mouseover", function() {
          infowin.open(marker.getMap(), marker);
        });

        // mouseoutイベントを取得するListenerを追加
        this.google.maps.event.addListener(marker, "mouseout", function() {
          infowin.close();
        });
      }
    }
  }
};
